export default __webpack_public_path__ + "static/media/(USDC:USDT).031ea8cc.png";